import { isEmpty } from "lodash";

import { cleanup } from "../security/PublicSecure";
import {
  ProgramContainer,
  FormSections,
} from "../entities/formTemplateDataType";
import { apiUrl } from "../config";
import { getPublicSecurePage, isBxpForm } from "./ElementUtils";
import TrackPageView from "./TrackPageView";
import { GlobalKeyValueService } from "./GlobalKeyValueService";
import { getEnvVar } from "../config/RuntimeConfig";

const getPathFromUrlOrPath = (value?: string | null) => {
  if (!value) {
    return "";
  }

  try {
    return new URL(value, window.location.origin).pathname.replace(/\/+$/, "");
  } catch {
    return value.replace(/\/+$/, "");
  }
};

const getStoredPreAuthUrl = (): string | null => {
  try {
    return (
      sessionStorage.getItem("preAuthUrl") || localStorage.getItem("preAuthUrl")
    );
  } catch {
    return null;
  }
};

const getStoredBpsAppId = (): string | null => {
  try {
    return sessionStorage.getItem("bps_appId");
  } catch {
    return null;
  }
};

export default class URLUtils {
  static concatUrls(url: string): string {
    // if (isRuntime() == 'false' && process.env.ENV !== 'local') {
    //     return window.location.href.replace("index.html", "") + url;
    // }
    // if(isRuntime() == 'true'){
    return (apiUrl() + "/" + url).replace(/([^:]\/)\/+/g, "$1");
    // } else {
    // const env = apiUrl()?.replace("on-form-service", "form-builder");
    // return (env + "/" + url).replace(/([^:]\/)\/+/g, "$1");
    // }
  }
}

export const goHome = (programContainer: ProgramContainer, lang = "en") => {
  let url;
  const app = programContainer.CategoryId.toLowerCase();
  if (programContainer.Profile.userId) {
    url =
      getEnvVar("PUBLIC_CXP_WEB_BASE_PATH") +
      "/auth/signin?redirectUri=/web" +
      (lang === "en" ? "" : "/fr") +
      "/dashboard";
  } else {
    url =
      lang === "en"
        ? "https://www.ontario.ca/page/government-ontario"
        : "https://www.ontario.ca/fr/page/gouvernement-de-lontario";
  }
  cleanup(app, programContainer);
  window.location.href = url;
};

export const getAppNameFromPath = () => {
  let paths = window.location.href.split("/on-form/#/");
  if (paths.length < 2) {
    if (window.location.href.includes("/on-form/fr/")) {
      paths = window.location.href.split("/on-form/fr/");
    } else {
      paths = window.location.href.split("/on-form/");
    }
  }
  const isBxp = paths.length >= 2 && isBxpForm(paths[1].toUpperCase());
  let storedUrl;
  if (isBxp) {
    //return paths[1].split('/')[0]
    storedUrl = window.location.href;
  } else {
    storedUrl = getStoredPreAuthUrl() || window.location.href;
  }
  let appName = "";

  if (storedUrl && !storedUrl.includes("#code=")) {
    storedUrl = storedUrl.replace("/fr", "");
    let pathSegmentsAll = storedUrl.split("#");
    if (pathSegmentsAll.length <= 1) {
      pathSegmentsAll = storedUrl.split("on-form");
    }
    if (pathSegmentsAll.length > 1) {
      //appName = pathSegmentsAll[1].replace(/\/+/g, "");
      appName =
        pathSegmentsAll[1].split("/").filter((segment) => segment !== "")[0] ||
        "";
    }
  }

  const resolvedAppName = appName.split("?")[0];
  if (resolvedAppName) {
    return resolvedAppName;
  }

  if (returnUrl()) {
    return getStoredBpsAppId() || "";
  }

  return resolvedAppName;
};

const hasAuthResponseParams = (params: URLSearchParams): boolean => {
  const authKeys = [
    "code",
    "error",
    "error_description",
    "errorCode",
    "errorDescription",
  ];
  return authKeys.some((key) => params.has(key));
};

export const returnUrl = () => {
  try {
    const searchParams = new URLSearchParams(window.location.search || "");
    const hashParams = new URLSearchParams(
      (window.location.hash || "").replace(/^#/, ""),
    );
    return (
      hasAuthResponseParams(searchParams) || hasAuthResponseParams(hashParams)
    );
  } catch {
    const storedUrl = window.location.href || "";
    return (
      storedUrl.includes("#code=") ||
      storedUrl.includes("?code=") ||
      storedUrl.includes("&code=") ||
      storedUrl.includes("#error=") ||
      storedUrl.includes("?error=") ||
      storedUrl.includes("&error=")
    );
  }
};

export const handleFormBuilderLink = () => {
  setTimeout(() => {
    sessionStorage.setItem("preAuthUrl", window.location.href);
    localStorage.setItem("preAuthUrl", window.location.href);
    window.location.reload();
  });
};

export const getSectionIndexFromPathname = (
  programContainer: ProgramContainer,
  pathName: string,
): number => {
  const sectionList = programContainer.ListOfFormSections.flatMap((p) => {
    return {
      index: p.Sequence,
      sectionName: p.ENUTitle.trim()
        .replace(/[^a-zA-Z0-9]/g, "-") // replace non-alphanumeric with dash
        .replace(/^-+/, "") // remove leading dashes
        .replace(/-+$/, ""), // remove trailing dashes
    };
  });
  const parts = pathName.replace(/\/$/, "").split("/"); // remove trailing slash and split
  const lastSegment = parts[parts.length - 1];

  const foundItem = sectionList.find(
    (p) => p.sectionName.toLowerCase() == lastSegment.toLowerCase(),
  );
  if (foundItem) {
    return foundItem.index - 1;
  }

  return -1;
};
export const normalizeUrl = (url) => {
  const [base, query] = url.split("?");
  if (query) {
    return base.toLowerCase() + "?" + query;
  }
  return base.toLowerCase();
};

export const normalizeCxpRedirectPath = (path: string) => {
  if (!path || typeof window === "undefined") {
    return path;
  }

  try {
    const url = new URL(path, window.location.origin);
    const configuredBasePath = getPathFromUrlOrPath(
      getEnvVar("PUBLIC_CXP_WEB_BASE_PATH"),
    );
    const basePathCandidates = Array.from(
      new Set(
        [configuredBasePath, "/web"]
          .filter(Boolean)
          .map((basePath) => basePath.replace(/\/+$/, "")),
      ),
    );

    let normalizedPathname = url.pathname;
    for (const basePath of basePathCandidates) {
      if (!basePath || basePath === "/") {
        continue;
      }

      if (
        normalizedPathname === basePath ||
        normalizedPathname.startsWith(`${basePath}/`)
      ) {
        const strippedPath =
          normalizedPathname.substring(basePath.length) || "/";
        if (/^\/on-form(?:\/|$)/i.test(strippedPath)) {
          normalizedPathname = strippedPath;
          break;
        }
      }
    }

    return `${normalizedPathname}${url.search}${url.hash}`;
  } catch {
    return path.replace(/^\/web(?=\/on-form(?:\/|$))/i, "");
  }
};

const getOnFormBasePaths = (): string[] => {
  if (typeof window === "undefined") {
    return [];
  }

  const pathname = (window.location.pathname || "").replace(/\/$/, "");
  const detectedBasePath =
    pathname.match(/^(.*?\/on-form(?:\/fr)?)(?:\/.*)?$/i)?.[1] || "/on-form";
  return Array.from(
    new Set([detectedBasePath, "/on-form", "/on-form/fr"].filter(Boolean)),
  );
};

export const getBxpAssetCandidates = (relativePath: string): string[] => {
  const sanitizedPath = relativePath.replace(/^\/+/, "");
  const relativeCandidates = [
    `./bxp-forms/${sanitizedPath}`,
    `./public/bxp-forms/${sanitizedPath}`,
    `/bxp-forms/${sanitizedPath}`,
    `/public/bxp-forms/${sanitizedPath}`,
  ];

  if (typeof window === "undefined") {
    return relativeCandidates;
  }

  const absoluteCandidates = getOnFormBasePaths().flatMap((basePath) => [
    `${window.location.origin}${basePath}/bxp-forms/${sanitizedPath}`,
    `${window.location.origin}${basePath}/public/bxp-forms/${sanitizedPath}`,
  ]);

  const rootAbsoluteCandidates = [
    `${window.location.origin}/bxp-forms/${sanitizedPath}`,
    `${window.location.origin}/public/bxp-forms/${sanitizedPath}`,
  ];

  return Array.from(
    new Set([
      ...relativeCandidates,
      ...absoluteCandidates,
      ...rootAbsoluteCandidates,
    ]),
  );
};

export const setParam = (url: string, param?: string, value?: string) => {
  if (!url || !param) return url;

  let newUrl = new URL(url);

  if (!value) {
    newUrl.searchParams.delete(param);
  } else {
    newUrl.searchParams.set(param, value);
  }
  return newUrl.toString();
};

export const getApiUrl = (path?: string) => {
  if (!getEnvVar("API_HOST") || !path) return "";
  const url =
    getEnvVar("API_HOST").replace(/\/$/, "") + `/${path}`.replace(/\/+/g, "/");
  return url;
};

/**
 * This helper method clones the provided URL, and removes '#/' from it. Due to the fact that,
 * URL.searchParams ignores the hash fragment (#) and anything that follows it in a URL.
 */
export const getCleansedUrl = (url: string) => {
  const clonedUrl = url.slice(0);
  return clonedUrl.replace("#/", "");
};

/**
 * This method copies all non-empty, non-object attributes from the source to the target object.
 */
export const copySimpleNonEmptyAttributes = (source: any, target: any) => {
  for (const key in source) {
    if (source[key] && typeof source[key] !== "object") {
      target[key] = source[key];
    }
  }
  if (isEmpty(target)) {
    return null;
  }
  return target;
};

export const isLocalhost = () =>
  window.location.hostname === "localhost" ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === "[::1]" ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
  );

export const combineUrl = (base, path) => {
  if (!path) return base;

  // If path already starts with http/https, just return it
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  // Ensure only one slash between base and path
  return base.replace(/\/+$/, "") + "/" + path.replace(/^\/+/, "");
};

export const slugifySectionName = (section?: Partial<FormSections>) => {
  const rawName = (section?.ENUTitle || section?.pageName || "").trim();
  if (!rawName) return "";
  return rawName
    .replace(/[^a-zA-Z0-9]/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+$/, "")
    ?.toLowerCase();
};

const isSectionSkippedFromWorkflow = ({
  section,
  isPublicSecureSection,
  isSignedIn,
  hasAcceptedTerms,
}: {
  section: Partial<FormSections> | undefined;
  isPublicSecureSection: boolean;
  isSignedIn: boolean;
  hasAcceptedTerms: boolean;
}) => {
  if (!section) return false;
  if (section?.Visible === false) return true;
  if (isPublicSecureSection && isSignedIn) return true;
  if (section?.SkipPageViewTracking && hasAcceptedTerms) return true;
  return false;
};

export const buildSectionUrl = (
  programContainer: ProgramContainer,
  section?: Partial<FormSections>,
  runtimeMode: string = getEnvVar("IS_RUNTIME"),
) => {
  if (!programContainer || !section) return null;

  const categoryId = programContainer.CategoryId;
  const isEng = !window.location.href.includes("/fr");
  const pageName = slugifySectionName(section);

  if (!categoryId || !pageName) return null;

  const basePath =
    runtimeMode === "true"
      ? isEng
        ? `${window.location.origin}/on-form/${categoryId}`
        : `${window.location.origin}/on-form/fr/${categoryId}`
      : isEng
        ? `${window.location.origin}/${categoryId}`
        : `${window.location.origin}/${categoryId}/fr`;

  const params = new URLSearchParams(window.location.search);
  const url = new URL(basePath);

  url.pathname = url.pathname.replace(/\/$/, "") + "/" + pageName;
  if (params.size > 0) {
    url.search = params.toString();
  }

  return normalizeUrl(url.toString());
};

export const pushSectionUrlToHistory = (
  programContainer: ProgramContainer,
  section: Partial<FormSections>,
  sectionIndex: number,
  runtimeMode?: string,
) => {
  const url = buildSectionUrl(programContainer, section, runtimeMode);
  if (!url) return;

  // Skip setting previousUrl and tracking if section is invisible
  if (section?.Visible === false) {
    console.log(
      "[pushSectionUrlToHistory] Skipping invisible section:",
      section.ENUTitle || section.FRATitle,
    );
    return;
  }

  // Skip if this is the public secure section and user is already signed in from CXP
  const publicSecureSection = getPublicSecurePage(
    programContainer?.ListOfFormSections as any,
  );
  const isPublicSecureSection =
    publicSecureSection && section === publicSecureSection;
  const isAlreadySignedIn = !!(
    programContainer?.Profile?.token ||
    programContainer?.Profile?.userId ||
    sessionStorage.getItem("userProfile")
  );
  const hasAcceptedTerms = !!(
    programContainer?.Profile?.agreedToTermsOfUseOn ||
    (programContainer as any)?.Entity?.accepted === true
  );

  if (
    isSectionSkippedFromWorkflow({
      section,
      isPublicSecureSection: !!isPublicSecureSection,
      isSignedIn: isAlreadySignedIn,
      hasAcceptedTerms,
    })
  ) {
    console.log(
      "[pushSectionUrlToHistory] Skipping section from workflow:",
      section.ENUTitle || section.FRATitle,
    );
    return;
  }

  const previousUrl = window.location.href;

  // Only set previousUrl if we're actually navigating to a different section
  // Compare just the pathname to ignore query parameter differences (like OAuth code/state params)
  const currentPath = window.location.pathname;
  const newUrl = new URL(url, window.location.origin);
  const newPath = newUrl.pathname;

  if (currentPath !== newPath) {
    // Before storing current URL as previousUrl, check if current section should be excluded
    const currentSectionIndex = getSectionIndexFromPathname(
      programContainer,
      currentPath,
    );
    let shouldStorePreviousUrl = true;

    console.log(
      "[pushSectionUrlToHistory] Checking if should store previousUrl:",
      {
        currentPath,
        newPath,
        currentSectionIndex,
        previousUrl,
      },
    );

    if (
      currentSectionIndex >= 0 &&
      currentSectionIndex < programContainer?.ListOfFormSections?.length
    ) {
      const currentSection =
        programContainer.ListOfFormSections[currentSectionIndex];

      console.log("[pushSectionUrlToHistory] Current section details:", {
        title: currentSection.ENUTitle,
        visible: currentSection.Visible,
        isPublicSecure:
          publicSecureSection && currentSection === publicSecureSection,
        skipPageViewTracking: currentSection.SkipPageViewTracking,
        isAlreadySignedIn,
      });

      const isCurrentPublicSecure = !!(
        publicSecureSection && currentSection === publicSecureSection
      );
      if (
        shouldStorePreviousUrl &&
        isSectionSkippedFromWorkflow({
          section: currentSection,
          isPublicSecureSection: isCurrentPublicSecure,
          isSignedIn: isAlreadySignedIn,
          hasAcceptedTerms,
        })
      ) {
        shouldStorePreviousUrl = false;
        console.log(
          "[pushSectionUrlToHistory] Not storing skipped current section as previousUrl:",
          currentSection.ENUTitle,
        );
      }
    }

    if (shouldStorePreviousUrl) {
      console.log(
        "[pushSectionUrlToHistory] Storing previousUrl:",
        previousUrl,
      );
      sessionStorage.setItem("previousUrl", previousUrl);
    } else {
      console.log(
        "[pushSectionUrlToHistory] NOT storing previousUrl (section should be skipped)",
      );
    }
  }
  // Track the current and public-secure section indices to coordinate analytics gating.
  if (Number.isFinite(sectionIndex)) {
    sessionStorage.setItem("currentSectionIndex", sectionIndex.toString());
    const sections = programContainer?.ListOfFormSections;
    const publicSecureSection = sections
      ? getPublicSecurePage(sections as any)
      : null;
    if (sections && publicSecureSection) {
      const psIndex = sections.indexOf(publicSecureSection as any);
      if (psIndex > -1) {
        sessionStorage.setItem("publicSecureSectionIndex", psIndex.toString());
      }
    }
  }

  const newState = {
    __app: true,
    sectionIndex,
  };

  window.history.pushState(newState, "", url);
  TrackPageView(programContainer);
};

export const getUserProfileValue = (key: string): string => {
  const userProfile = sessionStorage.getItem("userProfile");
  if (userProfile) {
    try {
      const profile = JSON.parse(userProfile);
      return profile[key] || "";
    } catch (e) {
      console.warn("Error parsing userProfile from sessionStorage:", e);
    }
  }
  return "";
};

export const resolveApiUrl = (
  apiUrl: string,
  options?: {
    page?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
    programContainer?: any;
  },
): string => {
  if (!apiUrl) return "";

  let resolvedUrl = apiUrl;

  if (options?.page !== undefined) {
    resolvedUrl = resolvedUrl.replace(/\{\{page\}\}/gi, String(options.page));
    resolvedUrl = resolvedUrl.replace(
      /\{\{pageIndex\}\}/gi,
      String(options.page),
    );
  }

  if (options?.pageSize !== undefined) {
    resolvedUrl = resolvedUrl.replace(
      /\{\{size\}\}/gi,
      String(options.pageSize),
    );
    resolvedUrl = resolvedUrl.replace(
      /\{\{pageSize\}\}/gi,
      String(options.pageSize),
    );
    resolvedUrl = resolvedUrl.replace(
      /\{\{limit\}\}/gi,
      String(options.pageSize),
    );

    if (options?.page !== undefined) {
      resolvedUrl = resolvedUrl.replace(
        /\{\{offset\}\}/gi,
        String(options.page * options.pageSize),
      );
    }
  }

  if (options?.sortField) {
    resolvedUrl = resolvedUrl.replace(/\{\{sortField\}\}/gi, options.sortField);
    resolvedUrl = resolvedUrl.replace(/\{\{sortBy\}\}/gi, options.sortField);
  }

  if (options?.sortOrder) {
    resolvedUrl = resolvedUrl.replace(/\{\{sortOrder\}\}/gi, options.sortOrder);
    resolvedUrl = resolvedUrl.replace(
      /\{\{sortDirection\}\}/gi,
      options.sortOrder,
    );
  }

  // Support {{serviceId}} from selectedService in sessionStorage
  const selectedServiceStr = sessionStorage.getItem("selectedService");
  if (selectedServiceStr) {
    try {
      const selectedService = JSON.parse(selectedServiceStr);
      if (selectedService?.serviceId) {
        resolvedUrl = resolvedUrl.replace(
          /{{serviceId}}/g,
          encodeURIComponent(String(selectedService.serviceId)),
        );
      }
    } catch (e) {}
  }

  const userId =
    getUserProfileValue("userId") ||
    getUserProfileValue("id") ||
    sessionStorage.getItem("userId");
  if (userId) {
    resolvedUrl = resolvedUrl.replace(
      /{{userId}}/g,
      encodeURIComponent(String(userId)),
    );
    resolvedUrl = resolvedUrl.replace(
      /{{USERID}}/g,
      encodeURIComponent(String(userId)),
    );
  }

  let operatorNumber = getUserProfileValue("operatorNumber");
  if (!operatorNumber) {
    // Fallback: use serviceId from selectedService (EHS Partner Portal stores operator number as serviceId)
    try {
      const svcStr = sessionStorage.getItem("selectedService");
      if (svcStr) {
        const svc = JSON.parse(svcStr);
        if (svc?.serviceId) operatorNumber = String(svc.serviceId);
      }
    } catch (e) {}
  }
  if (operatorNumber) {
    // Custom encoding: encode everything except & and =
    const customEncode = (str: string) => {
      return encodeURIComponent(str)
        .replace(/%26/g, "&") // Unescape &
        .replace(/%3D/g, "="); // Unescape =
    };
    resolvedUrl = resolvedUrl.replace(
      /{{operatorNumber}}/g,
      customEncode(String(operatorNumber)),
    );
  }

  const organizationId =
    getUserProfileValue("organizationId") ||
    sessionStorage.getItem("organizationId");
  if (organizationId) {
    resolvedUrl = resolvedUrl.replace(
      /{{organizationId}}/g,
      encodeURIComponent(String(organizationId)),
    );
  }

  // Support global key-value pairs
  // Get global key-value pairs for the current app
  const appName = options?.programContainer?.CategoryId;
  if (appName) {
    const globalPairs = GlobalKeyValueService.getKeyValuePairs(appName);
    globalPairs.forEach((pair) => {
      const placeholder = `{{${pair.key}}}`;
      resolvedUrl = resolvedUrl.replace(
        new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
        encodeURIComponent(pair.value),
      );
    });
  }

  if (options?.programContainer) {
    const placeholders: string[] = resolvedUrl.match(/\{\{([^}]+)\}\}/g) || [];
    placeholders.forEach((placeholder: string) => {
      const fieldId = placeholder.replace(/\{\{|\}\}/g, "");

      if (
        [
          "page",
          "pageIndex",
          "size",
          "pageSize",
          "offset",
          "limit",
          "sortField",
          "sortBy",
          "sortOrder",
          "sortDirection",
          "operatorNumber",
          "serviceId",
          "userId",
          "USERID",
          "organizationId",
        ].includes(fieldId.toLowerCase())
      ) {
        return;
      }

      const fieldValue = findFieldValueInContainer(
        options.programContainer,
        fieldId,
      );
      if (fieldValue) {
        resolvedUrl = resolvedUrl.replace(
          placeholder,
          encodeURIComponent(String(fieldValue)),
        );
      }
    });
  }

  const runtimeMode = getEnvVar("IS_RUNTIME");
  const apiBasePath = options?.programContainer?.APIBasePath;
  const isAbsoluteUrl = /^https?:\/\//i.test(resolvedUrl);
  if (runtimeMode === "true" && apiBasePath && !isAbsoluteUrl) {
    resolvedUrl = combineUrl(apiBasePath, resolvedUrl);
  }

  return resolvedUrl;
};

const findFieldValueInContainer = (
  programContainer: any,
  fieldId: string,
): string => {
  const sections = programContainer?.ListOfFormSections ?? [];

  const searchElements = (elements: any[]): string | null => {
    for (const element of elements ?? []) {
      if (element.Id === fieldId || element.LoadBindName === fieldId) {
        return element.Value ?? element.SelectionCode ?? "";
      }
      if (element.subSectionList?.length) {
        for (const sub of element.subSectionList) {
          const found = searchElements(sub?.ListOfFormSectionElements ?? []);
          if (found !== null) return found;
        }
      }
    }
    return null;
  };

  for (const section of sections) {
    for (const subSection of section.ListOfFormSubSections ?? []) {
      const found = searchElements(subSection.ListOfFormSectionElements ?? []);
      if (found !== null) return found;
    }
  }
  return "";
};
